import { useNavigate } from "@entry/navigation";

import { OnboardingLayoutProps } from "@components/OnboardingLayout";
import { Spacing, SpacingSizes } from "@components/Spacing";
import { BodySmall } from "@components/Typography";
import { Flow, Routes } from "@ctypes";
import { EntryStepLayout as OnboardingLayout } from "@entry/EntryStepLayout";
import { useGoalFlow, useTrumpSidecar } from "@hooks";
import { Translations, i18n } from "@i18n";

export const TrumpSidecarIntroductionRoute = () => {
  const navigate = useNavigate();

  const {
    goalProps: { flow },
  } = useGoalFlow();

  const { firstName, isSelf } = useTrumpSidecar();

  // Fall back to the first person copy when no name is available.
  const shouldUseSelfCopy = isSelf || !firstName;

  const props: OnboardingLayoutProps = {
    title: i18n.t(Translations.TrumpSidecarIntroductionRouteTitle),
    subtitle: shouldUseSelfCopy
      ? i18n.t(Translations.TrumpSidecarIntroductionRouteSubtitleSelf)
      : i18n.t(Translations.TrumpSidecarIntroductionRouteSubtitle, {
          firstName,
        }),
    hideLogout: flow !== Flow.Onboarding,
    cta: {
      primary: {
        title: i18n.t(Translations.TrumpSidecarIntroductionRoutePrimaryCTA),
        onClick: () => navigate(Routes.TrumpSidecarCurrentContribution),
      },
    },
  };

  return (
    <OnboardingLayout {...props}>
      <BodySmall>
        {shouldUseSelfCopy
          ? i18n.t(Translations.TrumpSidecarIntroductionRouteBody1Self)
          : i18n.t(Translations.TrumpSidecarIntroductionRouteBody1, {
              firstName,
            })}
      </BodySmall>
      <Spacing size={SpacingSizes.M} />

      <BodySmall>
        {shouldUseSelfCopy
          ? i18n.t(Translations.TrumpSidecarIntroductionRouteBody2Self)
          : i18n.t(Translations.TrumpSidecarIntroductionRouteBody2, {
              firstName,
            })}
      </BodySmall>
      <Spacing size={SpacingSizes.M} />
    </OnboardingLayout>
  );
};
